import { PaymentDirections } from './payment-directions';

export enum PaymentProfileRestrictionSettingsCodes {
    DailyLimit = 'account_settings.trader_settings.daily_limit_settings.daily_limit',
    IntervalBetweenOrders = 'account_settings.trader_settings.order_settings.interval_between_orders',
    MaxActiveOrders = 'account_settings.trader_settings.order_settings.max_active_orders',
    MaxDailyOrders = 'account_settings.trader_settings.order_settings.max_daily_orders',
    MaxOrderAmount = 'account_settings.trader_settings.order_settings.max_order_amount',
    MinOrderAmount = 'account_settings.trader_settings.order_settings.min_order_amount'
}

export interface PaymentProfileRestrictionSetting {
    code: PaymentProfileRestrictionSettingsCodes;
    value: string;
    upperLimit?: string;
}

export interface PaymentProfileRestriction {
    code: PaymentProfileRestrictionSettingsCodes;
    direction: PaymentDirections;
}
